export const CHANGE_TO_ADVANCED = 'changeToAdvanced';
export const CHANGE_TO_BASIC = 'changeToBasic';

export const SWITCH_TO_ADVANCED = 'switchToAdvanced';
export const SWITCH_TO_BASIC = 'switchToBasic';

export const WIZARD_STEP_CHANGE = 'wizardStepChange';

export const START_YARA_SCAN = 'startYaraScan';

export const YARA_VALIDITY_CHANGED = 'yaraValidityChanged';
export const YARA_VALUE_CHANGED = 'yaraValueChanged';

export const TARGET_CHANGE = 'targetChange';

export const YARA_CHARACTERS_LIMIT = 30000;

export const RULE_NAME_MAX_LENGTH = 128;
export const RULE_DESCRIPTION_MAX_LENGTH = 1024;
